function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
import * as Sentry from "@sentry/nextjs";
import { isValidSplideType } from "./splide-types.js";
import { SPLIDE_TYPE_SELECTOR, SPLIDE_TYPE_ATTRIBUTE } from "./splide-constants.js";
import { loadSplideCss, loadSplideSrc } from "./splide-loader.js";
import { initializeSplideInstance } from "./splide-factory.js";
export function initSplide(root) {
    return _initSplide.apply(this, arguments);
}
function _initSplide() {
    _initSplide = _async_to_generator(function*(root) {
        try {
            const target = root.querySelector(SPLIDE_TYPE_SELECTOR);
            const type = target === null || target === void 0 ? void 0 : target.getAttribute(SPLIDE_TYPE_ATTRIBUTE);
            if (!isValidSplideType(type)) {
                return;
            }
            yield loadSplideSrc();
            loadSplideCss();
            initializeSplideInstance(target, type);
        } catch (err) {
            Sentry.captureException(err);
            Sentry.captureMessage(`Failed to initialize Splide: ${err.message}`);
        }
    });
    return _initSplide.apply(this, arguments);
}
